import { useCallback, useEffect, useState } from 'react';
import { getMotionTier, prefersReducedMotion, setMotionTier, type MotionTier } from '@/lib/motion-effects';

export function useMotionTier() {
  const [tier, setTierState] = useState<MotionTier>(() => getMotionTier());

  useEffect(() => {
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    const sync = () => setTierState(getMotionTier());
    mq.addEventListener('change', sync);
    window.addEventListener('storage', sync);
    return () => {
      mq.removeEventListener('change', sync);
      window.removeEventListener('storage', sync);
    };
  }, []);

  const setTier = useCallback((next: MotionTier) => {
    setMotionTier(next);
    setTierState(next);
  }, []);

  const cycleTier = useCallback(() => {
    const order: MotionTier[] = ['subtle', 'normal', 'arcade'];
    const idx = order.indexOf(getMotionTier());
    const next = order[(idx + 1) % order.length]!;
    setTier(next);
  }, [setTier]);

  return {
    tier,
    setTier,
    cycleTier,
    reducedMotion: prefersReducedMotion(),
    isArcade: tier === 'arcade' && !prefersReducedMotion(),
  };
}
